import React from 'react';
import MonthToolbar from '../WorkPayrollSummary/MonthToolbar';

const StandaloneToolbar = (props) => {
  const { label, onNavigate } = props;
  return (
    <div>
      <MonthToolbar label={label} onNavigate={onNavigate} />
    </div>
  );
};

export default StandaloneToolbar;
